module.exports = __webpack_public_path__ + "static/media/Leopard Diary Logo 50x50.0aaadeec.png";